import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import {
  AvailableDatesRequest,
  AvailableDatesResponse,
  RealtyCapacityRequest,
  RealtyCapacityResponse,
  RealtyObject,
  RealtyPriceRequest,
  RealtyPriceResponse,
  RealtyPriceWithAvailabilityRequest,
  RealtyPriceWithAvailabilityResponse,
  RealtySearchRequest,
  RealtySearchResponse,
  RealtyType,
  RealtyTypesRequest,
} from './model'

const repeatableParamsSerializer = {
  indexes: null,
}

export const KyrgyzstanSearchApi = {
  getRealtyList(params: RealtySearchRequest, signal?: AbortSignal) {
    return clientApi.get<RealtySearchResponse>('/kyrgyzstan/realty-objects/', {
      params,
      paramsSerializer: repeatableParamsSerializer,
      signal,
    })
  },

  getRealtyDetail(objectId: string, signal?: AbortSignal) {
    return clientApi.get<Response<RealtyObject>>(
      `/kyrgyzstan/realty-objects/${objectId}`,
      { signal },
    )
  },

  getRealtyChildren(
    parentId: string,
    params?: Omit<RealtySearchRequest, 'page' | 'page_size'>,
    signal?: AbortSignal,
  ) {
    return clientApi.get<RealtySearchResponse>(
      `/kyrgyzstan/realty-objects/children/${parentId}`,
      {
        params,
        paramsSerializer: repeatableParamsSerializer,
        signal,
      },
    )
  },

  getFavorites(params: RealtySearchRequest, signal?: AbortSignal) {
    return clientApi.get<RealtySearchResponse>(
      '/kyrgyzstan/realty-objects/favorites',
      {
        params,
        paramsSerializer: repeatableParamsSerializer,
        signal,
      },
    )
  },

  getRealtyTypes(params?: RealtyTypesRequest, signal?: AbortSignal) {
    return clientApi.get<Response<RealtyType[]>>(
      '/kyrgyzstan/realty-objects/realty-types',
      {
        params,
        signal,
      },
    )
  },

  calculatePrice(params: RealtyPriceRequest) {
    return clientApi.post<Response<RealtyPriceResponse>>(
      '/kyrgyzstan/realty-objects/price',
      params,
    )
  },

  calculatePriceWithAvailability(
    params: RealtyPriceWithAvailabilityRequest,
    signal?: AbortSignal,
  ) {
    return clientApi.post<Response<RealtyPriceWithAvailabilityResponse>>(
      '/kyrgyzstan/realty-objects/price/with-availability',
      params,
      { signal },
    )
  },

  getRealtyCapacity(objectId: string, params: RealtyCapacityRequest) {
    return clientApi.get<Response<RealtyCapacityResponse>>(
      `/kyrgyzstan/realty-objects/${objectId}/capacity`,
      { params },
    )
  },

  getAvailableDates(objectId: string, params: AvailableDatesRequest) {
    return clientApi.get<Response<AvailableDatesResponse>>(
      `/kyrgyzstan/realty-objects/${objectId}/calendar/available`,
      { params },
    )
  },
}
